module.exports = __webpack_public_path__ + "img/isaac.f38b791f.png";